/**
 * 公共 url 无需授权
 */
const common = [
  '/reg-search',
  '/login',
  '/register',
  '/404',
]

/**
 * 验证权限
 * @param {*} url
 * @param {*} menuList
 * @param {*} key
 * @param {*} filed
 */
const isAuthUrl = (url, menuList = [], key = 'children', filed = 'href') => {
    if (typeof menuList !== 'object') menuList = []
    for (let menu of menuList) {
        if (menu[filed] && menu[filed] == url || menu[key] && isAuthUrl(url, menu[key], key, filed)) {
            return true
        }
    }
    return false
}

export default ({ req, app, store, redirect }) => {
    // Every time the route changes (fired on initialization too)
    // app.router.beforeEach((to, from, next) => {
        // if(to.path != '/uphold'){
        //   next('/uphold')
        // }else{
        //   next()
        // }
    //     /* must call `next` */
    //     // console.log('>>>to', to.path, store.state.menuList)
    //     if (common.indexOf(to.path) > -1 || isAuthUrl(to.path, isServer
    //             ? req.session.myMenu
    //             : store.state.menuList)) {
    //         next()
    //     } else {
    //         next('/404')
    //     }
    // })

    // app.router.beforeResolve((to, from, next) => {
    //     /* must call `next` */
    //     next()
    // })

    // app.router.afterEach((to, from) => { // 路由守卫导航
    //     //console.log(to)
    //     //do something to validate
    // })
 }



// WEBPACK FOOTER //
// ./plugins/route.js